import React, { ReactElement } from 'react'

import { ButtonClick, track } from '@dfds-frontend/tracking'

import Dialog from '@/app/[locale]/[ferry]/Dialog'

import { useTranslation } from '@/hooks/useDebugTranslations'

const onButtonClick = (
  model: OverlappingModel,
  action: 'ContinueAndReset' | 'Cancel' | 'CloseModal',
  canContinue: boolean,
  onContinue: (model: OverlappingModel) => void
) => {
  track<ButtonClick>({
    clickedElementText: '',
    event: 'buttonClick',
    eventAction: `remove${model.legNumber === 1 ? 'Return' : 'Outbound'}Departure${action}`,
  })
  onContinue({ ...model, continue: canContinue })
}

interface Props {
  model: OverlappingModel | undefined
  onContinue: (model: OverlappingModel) => void
}

const OverlappingModal: React.FC<Props> = ({ model, onContinue }: Props): ReactElement | null => {
  const { t } = useTranslation()

  if (!model) return null

  return (
    <Dialog
      dataAttr="overlapping-departures"
      description={t(`OVERLAPPING-MODAL-DESCRIPTION-${model.legNumber === 1 ? 'OUTBOUND' : 'RETURN'}`)}
      headline={t(`OVERLAPPING-MODAL-HEADING-${model.legNumber === 1 ? 'OUTBOUND' : 'RETURN'}`)}
      onPrimaryButtonClicked={() => onButtonClick(model, 'ContinueAndReset', true, onContinue)}
      onRequestClose={() => onButtonClick(model, 'Cancel', false, onContinue)}
      onSecondaryButtonClicked={() => onButtonClick(model, 'Cancel', false, onContinue)}
      primaryButtonText={t('BUTTON-CONTINUE-AND-RESET')}
      secondaryButtonText={t('CANCEL')}
      show={model.show}
    />
  )
}

export default OverlappingModal

export interface OverlappingModel {
  continue?: boolean
  departureId: string
  legNumber: 1 | 2
  productCode: string
  show: boolean
}
